import useUserInfoQuery from '@scoring-web/modules/user/hooks/queries/use-user-info-query.hook';
import { useEffect } from 'react';
import useInitializeAuthMutation from './hooks/mutations/use-initialize-auth-mutation.hook';
import useAuthHandler from './hooks/ui-handlers/use-auth-handler.hook';
import useErrorDialogHandler from './hooks/ui-handlers/use-error-dialog-handler.hook';
import useLoadingHandler from './hooks/ui-handlers/use-loading-handler.hook';

export default function useMainViewModel() {
  // #region Dependencies
  useUserInfoQuery();
  // #endregion

  // #region Mutations
  const initializeAuth = useInitializeAuthMutation();
  const { mutate: initialize } = initializeAuth;
  useEffect(() => {
    initialize();
  }, [initialize]);
  // #endregion

  // #region Handlers
  useAuthHandler();
  const loading = useLoadingHandler();
  const errorDialog = useErrorDialogHandler();
  // #endregion

  return { errorDialog, initializeAuth, loading };
}
